var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.76 2.873a2.98 2.98 0 0 1 4.216 0l2.151 2.151a2.98 2.98 0 0 1 0 4.216l-10.58 10.578a4.96 4.96 0 0 1-2.691 1.387l-4.692.781a1 1 0 0 1-1.15-1.15l.782-4.691a4.96 4.96 0 0 1 1.386-2.693zM5.596 14.866a2.96 2.96 0 0 0-.827 1.608l-.553 3.31 3.31-.553a2.96 2.96 0 0 0 1.608-.827l7.928-7.928-3.539-3.539zM17.562 4.287a.98.98 0 0 0-1.388 0l-1.236 1.236 3.538 3.539 1.237-1.236a.98.98 0 0 0 0-1.388z",
    clipRule: "evenodd"
  })));
};
export default Svg24;